import axios from 'axios';

const EDITORIAL_ACCESS = 'v3/editorial-access';

export function getEditorialAccessMe(signal) {
  return axios.get(`${EDITORIAL_ACCESS}/me`, { signal });
}

export function getEditorialAccessProfile(userGuid, signal) {
  return axios.get(`${EDITORIAL_ACCESS}/users/${userGuid}`, { signal });
}

export function putEditorialAccessProfile(userGuid, profile) {
  return axios.put(`${EDITORIAL_ACCESS}/users/${userGuid}`, profile);
}

export function getEditorialUsers(params, signal) {
  return axios.get(`${EDITORIAL_ACCESS}/users`, { params, signal });
}
